"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserFlag;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _userAvatar = require("@insided/shared/utils/userAvatar");

function UserFlag(user) {
  return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
    var _user$size, _user$id;

    return (0, _preact.h)("div", {
      className: "user flag"
    }, (0, _preact.h)("div", {
      className: "flag__image"
    }, (0, _preact.h)("div", {
      className: "avatar avatar--".concat((_user$size = user.size) !== null && _user$size !== void 0 ? _user$size : 'S')
    }, (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/members/").concat((0, _toKebabCase.textToKebab)(user.name), "-").concat(user.id)),
      className: "qa-profilepicture"
    }, (0, _preact.h)("div", {
      className: "profilepicture profile--dropdown-trigger"
    }, user.avatar ? (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(user.avatar.replace('90x90', '100x100')),
      alt: user.name
    }) : (0, _preact.h)("div", {
      className: "default-avatar avatar-variant-".concat(((_user$id = user.id) !== null && _user$id !== void 0 ? _user$id : 0) % 10)
    }, (0, _userAvatar.getAvatarInitial)(user.name))), modules.includes('rank') && user.rankIcon ? (0, _preact.h)("div", {
      className: "profilelabel"
    }, (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(user.rankIcon),
      title: user.rankName,
      alt: user.rankName
    })) : null))));
  });
}